import iconIG from "../../assets/icons/ig.png";
import iconStore from "../../assets/icons/shop.png";
import iconYT from "../../assets/icons/yt.png";
import iconLinkedin from "../../assets/icons/linkedin.png";
import iconTiktok from "../../assets/icons/tiktok.png";
import iconSteam from "../../assets/icons/steam.png";
import { Clickable } from "../clickable.container";

export const FooterLinks = () => {
  return (
    <div className="footer-links">
      {/* <Clickable  FALI LINKEDIN I REDDIT
            onclick={() => {
              window.open(
                "https://www.youtube.com/watch?v=MTsAHMC0WPM",
                "_blank"
              ); //_self umisto blank ako ide u isti tab
            }}
            children=""
            backgroundUrl={iconLinkedin}
            style="footer-link"
          /> */}
      <Clickable
        onclick={() => {
          window.open("https://vertexhorizons.gumroad.com/", "_blank");
        }}
        children=""
        backgroundUrl={iconStore}
        style="footer-link"
      />
      <Clickable
        onclick={() => {
          window.open("https://www.tiktok.com/@vertexhorizons", "_blank");
        }}
        children=""
        backgroundUrl={iconTiktok}
        style="footer-link"
      />
      <Clickable
        onclick={() => {
          window.open("https://www.instagram.com/vertexhorizons/", "_blank");
        }}
        children=""
        backgroundUrl={iconIG}
        style="footer-link"
      />
      <Clickable
        onclick={() => {
          window.open("https://www.youtube.com/@VertexHorizons", "_blank");
        }}
        children=""
        backgroundUrl={iconYT}
        style="footer-link"
      />
      <Clickable
        onclick={() => {
          window.open(
            "https://store.steampowered.com/app/3623600/Evergrow_Shards_of_Tomorrow/",
            "_blank"
          );
        }}
        children=""
        backgroundUrl={iconSteam}
        style="footer-link"
      />
    </div>
  );
};
